import React, { createContext, useContext, useState } from 'react';

const GenderRankingProbContext = createContext();

export const useGender = () => useContext(GenderRankingProbContext);

export const GenderRankingProbProvider = ({ children }) => {
  const [selectedGender, setSelectedGender] = useState('Men');

  return <GenderRankingProbContext.Provider value={{ selectedGender, setSelectedGender }}>{children}</GenderRankingProbContext.Provider>;
};
